import React from 'react';
import { GiftIcon } from 'lucide-react';
import { offerAnchor } from '../data/content';
import { bonuses, pricing } from '../data/bonuses';
import { BonusCard } from './BonusCard';
import { Button } from './ui/Button';
export function Bonuses() {
  return <section id="bonuses" className="bg-teal-800 px-4 py-12 md:py-16" data-id="element-32" data-mp="asz34ehj8c2g">
      <div className="mx-auto max-w-3xl text-center" data-id="element-33" data-mp="fsv7ieu565ij">
        <GiftIcon className="mx-auto h-8 w-8 text-amber-300" aria-hidden="true" data-id="element-34" data-mp="1un5hsi90e0i" />
        <h2 className="mt-3 text-2xl font-black uppercase leading-tight text-white md:text-4xl" data-id="element-35" data-mp="1wriczy4kncx">
          Includes <span className="text-amber-300" data-id="element-36" data-mp="3o1lferpctljg">5 practical bonuses</span>
        </h2>
      </div>

      <div className="mx-auto mt-8 max-w-3xl space-y-4" data-id="element-37" data-mp="3o3y2fj9yym3d">
        {bonuses.map(bonus => <BonusCard key={bonus.number} bonus={bonus} data-id="element-38" data-mp="3t2j6jtscdpx3" />)}
        <div className="flex flex-col items-center justify-center rounded-2xl border-2 border-dashed border-amber-300 p-5 text-center" data-id="element-39" data-mp="1martlmorw830">
          <p className="text-[11px] font-extrabold uppercase tracking-wider text-white/85" data-id="element-40" data-mp="1r6yyrd9chfjw">
            Total reference value of the 5 bonuses
          </p>
          <span className="mt-1 text-3xl font-black text-white/85 line-through decoration-red-500 decoration-4" data-id="element-41" data-mp="3dek4p7xnslmv">
            ${pricing.bonusValue} USD
          </span>
          <p className="mt-1 text-lg font-black uppercase text-amber-300" data-id="element-42" data-mp="3n4mw53p4trj3">All 5 bonuses included free</p>
        </div>
        <div className="pt-4 text-center" data-id="element-43" data-mp="2zglpk0bikl6b">
          <Button href={offerAnchor} size="lg" subtext="Claim your $61 in bonuses before the launch price ends" data-id="element-44" data-mp="2zhojkh44v3qg">
            Yes! Send me all 5 bonuses free
          </Button>
        </div>
      </div>
    </section>;
}